import { render } from "./HomeLayout.vue?vue&type=template&id=21db3455&scoped=true"
import script from "./HomeLayout.vue?vue&type=script&lang=js"
export * from "./HomeLayout.vue?vue&type=script&lang=js"

import "./HomeLayout.vue?vue&type=style&index=0&id=21db3455&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21db3455"]])

export default __exports__